document.addEventListener('DOMContentLoaded', function () {

  const videoSection = document.querySelector('.all_videosWrap');
  const popup = document.querySelector('.prodVideo_ContentWrap');

  if (!videoSection || !popup) return;


  const slider = popup.querySelector('.prodVideoSlider');
  const closeBtn = popup.querySelector('.closeBtn');
  const overlay = popup.querySelector('.popOverlay');
  const prevBtn = popup.querySelector('.prevVideo');
  const nextBtn = popup.querySelector('.nextVideo');


  const cards = Array.from(
    videoSection.querySelectorAll('.videoCard')
  );


  if (!cards.length) return;


  let currentIndex = 0;


  /*
   * Get the actual video source from
   * Shopify's generated video element.
   */
  function getVideoUrl(card) {

    const source = card.querySelector('.media_video video source');

    if (source && source.src) {
      return source.src;
    }


    const video = card.querySelector('.media_video video');

    if (video && video.src) {
      return video.src;
    }


    return '';
  }


  /*
   * Show selected video
   */
  function showVideo(index) {

    /*
     * Loop backwards:
     * First video → Last video
     */
    if (index < 0) {
      index = cards.length - 1;
    }


    /*
     * Loop forwards:
     * Last video → First video
     */
    if (index >= cards.length) {
      index = 0;
    }


    currentIndex = index;


    const card = cards[currentIndex];

    if (!card) return;


    const videoUrl = getVideoUrl(card);
    const title = card.dataset.title || '';


    if (!videoUrl) {
      console.warn('Video source not found.');
      return;
    }


    /*
     * Remove the previous video.
     */
    slider.innerHTML = '';


    /*
     * Create video wrapper.
     */
    const videoWrapper = document.createElement('div');

    videoWrapper.className = 'popupVideoItem';


    /*
     * Create video element.
     */
    const video = document.createElement('video');

    video.src = videoUrl;

    video.autoplay = true;

    video.controls = true;

    video.playsInline = true;

    video.preload = 'auto';

    video.muted = false;


    /*
     * Add video to wrapper.
     */
    videoWrapper.appendChild(video);


    /*
     * Add video title.
     */
    if (title) {

      const titleElement = document.createElement('div');

      titleElement.className = 'popupVideoTitle';

      titleElement.textContent = title;

      videoWrapper.appendChild(titleElement);

    }


    /*
     * Add wrapper to popup.
     */
    slider.appendChild(videoWrapper);


    /*
     * Open popup.
     */
    popup.classList.add('active');

    popup.setAttribute('aria-hidden', 'false');

    document.body.classList.add('video-popup-open');


    /*
     * =====================================================
     * AUTOMATICALLY GO TO NEXT VIDEO WHEN FINISHED
     * =====================================================
     *
     * The nextVideo() function already handles:
     *
     * Video 1 → Video 2
     * Video 2 → Video 3
     * ...
     * Last Video → First Video
     *
     */
    video.addEventListener('ended', function () {
      nextVideo();
    });


    /*
     * Attempt autoplay.
     *
     * Browser autoplay policies may prevent
     * unmuted autoplay.
     */
    const playPromise = video.play();

    if (playPromise !== undefined) {

      playPromise.catch(function () {

        /*
         * Autoplay was blocked.
         * The native video controls remain available
         * so the user can manually start playback.
         */

      });

    }


    /*
     * Update navigation.
     */
    updateNavigation();
  }

  /*
   * =====================================================
   * PREVIOUS VIDEO
   * =====================================================
   */
  function previousVideo() {
    showVideo(currentIndex - 1);
  }

  /*
   * =====================================================
   * NEXT VIDEO
   * =====================================================
   */
  function nextVideo() {
    showVideo(currentIndex + 1);
  }

  /*
   * =====================================================
   * UPDATE NAVIGATION
   * =====================================================
   */
  function updateNavigation() {
    /*
     * If there is only one video,
     * disable both navigation buttons.
     */
    if (cards.length <= 1) {
      prevBtn.disabled = true;
      nextBtn.disabled = true;
    } else {
      prevBtn.disabled = false;
      nextBtn.disabled = false;
    }
  }


  /*
   * =====================================================
   * CLOSE POPUP
   * =====================================================
   */
  function closePopup() {
    const video = slider.querySelector('video');
    if (video) {
      /*
       * Stop video.
       */
      video.pause();
      /*
       * Remove source to stop loading/playback.
       */
      video.removeAttribute('src');
      video.load();
    }

    /*
     * Remove video from popup.
     */
    slider.innerHTML = '';

    /*
     * Hide popup.
     */
    popup.classList.remove('active');
    popup.setAttribute('aria-hidden', 'true');

    /*
     * Restore page scrolling.
     */
    document.body.classList.remove('video-popup-open');
  }


  /*
   * =====================================================
   * VIDEO CARD CLICK
   * EVENT DELEGATION
   * =====================================================
   */
  videoSection.addEventListener('click', function (event) {
    const card = event.target.closest('.videoCard');
    if (!card || !videoSection.contains(card)) {
      return;
    }

    /*
     * If the title link is clicked,
     * allow the link to work normally.
     */
    if (event.target.closest('a')) {
      return;
    }

    /*
     * Find the clicked card's index.
     */
    const index = cards.indexOf(card);
    if (index !== -1) {
      showVideo(index);
    }
  });

  /*
   * =====================================================
   * PREVIOUS BUTTON
   * =====================================================
   */
  prevBtn.addEventListener('click', function (event) {
    event.stopPropagation();
    previousVideo();
  });


  /*
   * =====================================================
   * NEXT BUTTON
   * =====================================================
   */
  nextBtn.addEventListener('click', function (event) {
    event.stopPropagation();
    nextVideo();
  });


  /*
   * =====================================================
   * CLOSE BUTTON
   * =====================================================
   */
  closeBtn.addEventListener('click', function (event) {
    event.stopPropagation();
    closePopup();
  });


  /*
   * =====================================================
   * OVERLAY CLICK
   * =====================================================
   */
  overlay.addEventListener('click', function () {
    closePopup();
  });


  /*
   * =====================================================
   * KEYBOARD CONTROLS
   * =====================================================
   */
  document.addEventListener('keydown', function (event) {
    /*
     * Do nothing if popup isn't open.
     */
    if (!popup.classList.contains('active')) {
      return;
    }
    /*
     * ESC → Close
     */
    if (event.key === 'Escape') {
      closePopup();
    }
    /*
     * LEFT ARROW → Previous
     */
    else if (event.key === 'ArrowLeft') {
      previousVideo();
    }
    /*
     * RIGHT ARROW → Next
     */
    else if (event.key === 'ArrowRight') {
      nextVideo();
    }
  });
});